const actions = {
  LIST_ESTADO: 'LIST_ESTADO',
  LIST_MUNICIPIO: 'LIST_MUNICIPIO',
  LIST_EMPLEADO_ESQUEMAS_CONTRACTUALES: 'LIST_EMPLEADO_ESQUEMAS_CONTRACTUALES',
  LIST_TIPO_EMPLEADO: 'LIST_TIPO_EMPLEADO',
  LIST_SUCURSAL_ESQUEMAS_CONTRACTUALES: 'LIST_SUCURSAL_ESQUEMAS_CONTRACTUALES',
  LIST_SUCURSAL_ESQUEMAS_COSTOS: 'LIST_SUCURSAL_ESQUEMAS_COSTOS',
  LIST_SERVICIOS: 'LIST_SERVICIOS',
  
  estadosList: data => {  
    return {
      type: actions.LIST_ESTADO,
      data,
    };
  },

  municipioList: data => {  
    return {
      type: actions.LIST_MUNICIPIO,
      data,
    };
  },
  empleadoEsquemasContractualesList: data => {  
    return {
      type: actions.LIST_EMPLEADO_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },
  tipoEmpleadosList: data => {  
    return {
      type: actions.LIST_TIPO_EMPLEADO,
      data,
    };
  },
  sucursalEsquemasContractualesList: data => {  
    return {
      type: actions.LIST_SUCURSAL_ESQUEMAS_CONTRACTUALES,
      data,
    };
  },
  sucursalEsquemasCostosList: data => {  
    return {
      type: actions.LIST_SUCURSAL_ESQUEMAS_COSTOS,
      data,
    };
  },

  serviciosList: data => {  
    return {
      type: actions.LIST_SERVICIOS,
      data,
    };
  },

};

export default actions;
